import {
  customElement,
  FASTElement,
  observable,
} from '@microsoft/fast-element';
import { AnalyticsStepThreeTemplate as template } from './analytics-step-three.template';
import { AnalyticsStepThreeStyles as styles } from './analytics-step-three.styles';
import { VppaRankings } from '../../../../types';
import { IBuyerAnalyticsService, IVppaService } from '../../../../services';
import { IEnumService } from '../../../../services/enum.service';

const name = 'analytics-step-three';

@customElement({
  name,
  template,
  styles,
})
export class AnalyticsStepThree extends FASTElement {
  @IBuyerAnalyticsService buyerAnalyticsService: IBuyerAnalyticsService;
  @IVppaService vppaService: IVppaService;
  @IEnumService enumService: IEnumService;

  @observable selectedVppaRankings: VppaRankings[] = [];

  connectedCallback() {
    super.connectedCallback();
    this.selectedVppaRankings = this.buyerAnalyticsService.stepTwoSelectedVppas;
  }
}
